module.exports = __webpack_public_path__ + "static/QUUBBold-1f6bc7d42c6e5a794ffde3d936f71bfc.ttf";